import { isMobile } from "@/utils/common";
import React from "react";
import DragSelectMobile from "./mobile";
import DragSelectWeb from "./web";

function index(props) {
  return <DragSelectMobile {...props} />;

  return isMobile ? (
    <DragSelectMobile {...props} />
  ) : (
    <DragSelectWeb {...props} />
  );
}
export default index;
